// extracted by mini-css-extract-plugin
export default {"login_sidebar":"_9adF","background_image":"_35MN"};